import lowerCase from 'lodash/lowerCase';
import * as React from 'react';
import memoize from 'lodash/memoize';

interface Props {
  entity?: string;
  adaUrl?: string;
}

export const BillingDocMessageRefund = ({ adaUrl, entity }: Props) => {
  if (!(entity && adaUrl)) {
    return null;
  }
  const getViewInAdaQuoteUrl = memoize(
    (baseUrl?: string, id?: string) => {
      const idNumber = id?.startsWith('RF-') ? id.slice(3) : id;
      if (id && baseUrl) {
        return `${baseUrl}/ViewRefund.jspa?refundId=${idNumber}`;
      }
      return '';
    },
    (...arg) => arg[1]
  );
  return (
    <div id="billing-doc-message" data-testid="billing-doc-message">
      <div className="info-banner" style={{ marginBottom: '32px' }}>
        <strong style={{ marginRight: '4px' }}>INTERNAL USE ONLY.</strong>
        This page is not a legal document - please go to ADA to get a copy of the{' '}
        <a target="_blank" rel="noopener" href={getViewInAdaQuoteUrl(adaUrl, entity)}>
          official refund→
        </a>
      </div>
    </div>
  );
};
